
















































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import Search from "@/components/UI/Search.vue";
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IExport from '@/components/icons/IExport.vue'

const auth = namespace('auth')
const profile = namespace("profile")
const products = namespace("products")
const dialog = namespace('dialog')
const forms = namespace('forms')

@Component({
  components: {
    Search,
    BtnDefault,
    'i-export': IExport,
  }
})

export default class ProductsToolbar extends Vue {
    @profile.State("userCompany") protected userCompany: any
    @products.Action('saveNewProduct') protected saveNewProduct:any
    @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
    @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
    @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any

    @dialog.Getter('fullDialogShow') protected fullDialogShow: any
    @forms.Mutation('setOptions') protected setOptions: any

    @Prop({type: Boolean, default: false}) isSelectedProduct !:any
    @Prop({type: String, default: ''}) search !:string

    disableSearch:boolean = false

    exportAll() {
      this.$emit('exportAll')
    }

    clearSearch() {
      this.$emit('clearSearch')
    }

    addProduct() {
      this.setOptions()
      this.SetTitleDialog(this.$t('products.add.title'))
      this.SetFormSDialog('AddProductForm')
      this.SetFullDialogShow(true)
    }
}
